export function isPermitDetailFcmTitle(title) {
  return String(title ?? '').trim().startsWith('작업허가서');
}

export function isPermitDetailAlarmGubun(gubun) {
  return String(gubun ?? '').startsWith('AL_002');
}
